export class AuthJuniorDto {
  sanctioning_club: string;
  junior_number: string;
  password: string;
}
